import { render, staticRenderFns } from "./InsurerConsumables.vue?vue&type=template&id=764719e0"
import script from "./InsurerConsumables.vue?vue&type=script&lang=js"
export * from "./InsurerConsumables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports